import { StateEffect, StateField } from "@codemirror/state";
import { Decoration, DecorationSet, EditorView } from "@codemirror/view";

export const setHighlightEffect = StateEffect.define<{
  from: number;
  to: number;
} | null>();

export const highlightStateField = StateField.define<DecorationSet>({
  create() {
    return Decoration.none;
  },
  update(decorations, tr) {
    for (const effect of tr.effects) {
      if (effect.is(setHighlightEffect)) {
        if (effect.value) {
          const docLength = tr.state.doc.length;
          if (docLength === 0) {
            return Decoration.none;
          }
          const rawFrom = effect.value.from || 0;
          const rawTo = effect.value.to || 0;
          const from = Math.max(0, Math.min(rawFrom, docLength));
          const to = Math.max(from, Math.min(rawTo, docLength));
          if (from === to) {
            return Decoration.none;
          }
          const highlightMark = Decoration.mark({
            class: "cm-statement-highlight",
          });
          return Decoration.set([highlightMark.range(from, to)]);
        }
        return Decoration.none;
      }
    }

    if (tr.docChanged) {
      return decorations.map(tr.changes);
    }

    return decorations;
  },
  provide: f => EditorView.decorations.from(f),
});

export const highlightStatementTheme = EditorView.theme({
  ".cm-statement-highlight": {
    backgroundColor: "var(--grey_stroke_1)",
  },
});

export const highlightStatementExtension = [
  highlightStateField,
  highlightStatementTheme,
];
